import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import Layout from '../components/Dashboard/Layout/Dynamic';
import withApollo from '../lib/apollo';
import loading from '../lib/loading';
import { CaptchaProvider } from '../components/Captcha';
import { UserContext } from '../components/UserProvider';
import { hasRoleInAnyGroup } from '../lib/hasUserRoles';

const JobForm = dynamic(
  () => import('../components/Jobs/JobForm'), {
    ssr: false,
    loading,
  },
);

const MaybeWrapWithCaptchaProvider = ({
  showCaptcha,
  children,
}) => (
  showCaptcha ? <CaptchaProvider>{children}</CaptchaProvider> : children
);

MaybeWrapWithCaptchaProvider.propTypes = {
  showCaptcha: PropTypes.bool,
  children: PropTypes.node,
};

MaybeWrapWithCaptchaProvider.defaultProps = {
  showCaptcha: false,
  children: null,
};

const possibleRoles = [
  'createJob',
  'createApprovalJob',
  'createRestrictedJob',
];

export const JobFormPage = () => {
  const { roles } = useContext(UserContext);
  const showCaptcha = !roles || !possibleRoles
    .some((role) => hasRoleInAnyGroup(roles, role));

  return (
    <Layout layoutMaxWidth="840px">
      <MaybeWrapWithCaptchaProvider showCaptcha={showCaptcha}>
        <JobForm showCaptcha={showCaptcha} />
      </MaybeWrapWithCaptchaProvider>
    </Layout>
  );
};

JobFormPage.getLayout = (page) => page;

export default withApollo(JobFormPage);
